export type LegacyWorkScheduleOffice = {
  id: string
  name: string
}

export type LegacyScheduleEntry = {
  id: string
  officeId: string
  date: string
  time: string
  customer: string
  customerId?: string
  staffId?: string
  workgroupId?: string
  group?: string
  title: string
  memo: string
  status: string
}

export type LegacyWorkScheduleGroup = {
  staff: string
  staffId: string
  workgroupId: string
  entries: LegacyScheduleEntry[]
}

/** 비식별·하드코딩된 업무 일지 UI 데이터. */
export const legacyWorkScheduleOffices: LegacyWorkScheduleOffice[] = [
  { id: 'mock-office-a', name: 'Mock 지점 A' },
  { id: 'mock-office-b', name: 'Mock 지점 B' },
  { id: 'mock-office-c', name: 'Mock 지점 C' },
]

const officeIds = legacyWorkScheduleOffices.map(({ id }) => id)

const dateWithOffset = (offset: number) => {
  const value = new Date(2026, 7, 29 + offset)
  return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
}

const rangedMockDate = (sequence: number) => {
  const offset = sequence % 3 === 0
    ? -100 + ((sequence * 11) % 201)
    : -30 + ((sequence * 7) % 61)
  return dateWithOffset(offset)
}

const makeEntries = (prefix: string, start: number, staffId: string, workgroupId: string): LegacyScheduleEntry[] =>
  Array.from({ length: 30 }, (_, index) => {
    const sequence = start + index
    const hasCustomer = sequence % 4 !== 0
    return {
      id: `${prefix}-${index + 1}`,
      officeId: officeIds[sequence % officeIds.length],
      date: rangedMockDate(sequence),
      time: `${String(9 + (sequence % 8)).padStart(2, '0')}:00`,
      customer: hasCustomer ? `Mock 고객 ${String.fromCharCode(65 + (sequence % 8))}` : '-',
      customerId: hasCustomer ? `mock-customer-${1 + (sequence % 8)}` : undefined,
      staffId,
      workgroupId,
      title: `Mock 업무 일정 ${sequence + 1}`,
      memo: 'Mock 일정 내용',
      status: sequence % 5 === 0 ? '대기' : '진행',
    }
  })

export const legacyWorkScheduleGroups: LegacyWorkScheduleGroup[] = [
  { staff: 'Mock 작업자 A', staffId: 'mock-staff-a', workgroupId: 'mock-workgroup-a', entries: makeEntries('work-a', 0, 'mock-staff-a', 'mock-workgroup-a') },
  { staff: 'Mock 작업자 B', staffId: 'mock-staff-b', workgroupId: 'mock-workgroup-b', entries: makeEntries('work-b', 30, 'mock-staff-b', 'mock-workgroup-b') },
  { staff: 'Mock 작업자 C', staffId: 'mock-staff-c', workgroupId: 'mock-workgroup-c', entries: makeEntries('work-c', 60, 'mock-staff-c', 'mock-workgroup-c') },
  { staff: 'Mock 작업자 D', staffId: 'mock-staff-d', workgroupId: 'mock-workgroup-d', entries: makeEntries('work-d', 90, 'mock-staff-d', 'mock-workgroup-d') },
]

export const legacyNormalSchedules: LegacyScheduleEntry[] = Array.from({ length: 90 }, (_, index) => {
  const hasCustomer = index % 3 !== 0
  return {
    id: `normal-${index + 1}`,
    officeId: officeIds[index % officeIds.length],
    date: rangedMockDate(index + 120),
    time: `${String(9 + (index % 8)).padStart(2, '0')}:30`,
    customer: hasCustomer ? `Mock 고객 ${String.fromCharCode(65 + (index % 8))}` : '-',
    customerId: hasCustomer ? `mock-customer-${1 + (index % 8)}` : undefined,
    staffId: 'mock-current-staff',
    workgroupId: `mock-workgroup-${String.fromCharCode(97 + (index % 3))}`,
    group: `Mock 그룹 ${String.fromCharCode(65 + (index % 3))}`,
    title: `Mock 일반 일정 ${index + 1}`,
    memo: 'Mock 일반 일정 내용',
    status: index % 4 === 0 ? '대기' : '진행',
  }
})

export const legacyPhotoSchedules: LegacyScheduleEntry[] = Array.from({ length: 24 }, (_, index) => ({
  id: `photo-${index + 1}`,
  officeId: officeIds[index % officeIds.length],
  date: `2026-08-${String(20 + (index % 10)).padStart(2, '0')}`,
  time: `${String(9 + (index % 9)).padStart(2, '0')}:00`,
  customer: `Mock 고객 ${String.fromCharCode(65 + (index % 8))}`,
  customerId: `mock-customer-${1 + (index % 8)}`,
  title: `Mock 촬영 일정 ${index + 1}`,
  memo: 'Mock 촬영 내용',
  status: index % 2 ? '진행' : '대기',
}))

export const legacyWorkScheduleMemos: Record<string, string> = {
  '2026-08-20': '<p>Mock 업무 일지 메모입니다.</p>',
  '2026-08-29': '<p>Mock 월말 확인 메모입니다.</p>',
}
